import { Link } from "@tanstack/react-router";

import { Button } from "~/components/ui/button";
import { EmptyState } from "~/components/ui/empty-state";

export function DefaultNotFound() {
  return (
    <div className="grid min-h-[60vh] flex-1 place-items-center p-6">
      <EmptyState
        className="w-full max-w-[560px]"
        title="Deze pagina bestaat niet"
        action={
          <Button asChild variant="primary" size="sm">
            <Link to="/">Naar het overzicht</Link>
          </Button>
        }
      >
        Controleer het adres, of ga terug naar je overzicht.
      </EmptyState>
    </div>
  );
}
